module.exports = __webpack_public_path__ + "static/media/webchat.c19e7d7f.svg";